import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsModule } from '@progress/kendo-angular-utils';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import {
  provideNgxMask,
  NgxMaskDirective,
  NgxMaskPipe,
} from 'ngx-mask';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChartModule } from '@progress/kendo-angular-charts';
import { UIModule } from '@ups/xplat/web/features';
import {
  DYNAMIC_COMPONENT_MAPPING,
  DYNAMIC_ITEM_COMPONENTS,
} from './components/component-mapping';
import {
  DynamicRenderModule as SharedDynamicRenderModule,
  PlatformDynamicComponentsToken,
} from '@ups/xplat/dynamic-render';
import { DYNAMIC_MODALS } from './modals';
import { DYNAMIC_CONTAINER_COMPONENTS } from './containers';
import { DYNAMIC_PAGE_COMPONENTS } from './pages';
import { DynamicItemHintPipe } from './components/dynamic-typeaheads/dynamic-typeahead/dynamic-item-hint.pipe';
import { KeepSelectionOnEscDirective } from './components/dynamic-typeaheads/base/keep-selection-on-esc.directive';

const MODULES = [
  CommonModule,
  UIModule,
  UtilsModule,
  DashboardLayoutModule,
  DragDropModule,
  ChartModule,
  InputsModule,
  DateInputsModule,
  NgxMaskDirective,
  NgxMaskPipe,
  AccordionModule,
  SharedDynamicRenderModule,
  DynamicItemHintPipe,
  KeepSelectionOnEscDirective,
];

@NgModule({
  declarations: [
    ...DYNAMIC_ITEM_COMPONENTS,
    ...DYNAMIC_MODALS,
    ...DYNAMIC_CONTAINER_COMPONENTS,
    ...DYNAMIC_PAGE_COMPONENTS,
  ],
  exports: [
    ...DYNAMIC_ITEM_COMPONENTS,
    ...DYNAMIC_MODALS,
    ...DYNAMIC_CONTAINER_COMPONENTS,
    ...DYNAMIC_PAGE_COMPONENTS,
    ...MODULES,
  ],
  imports: [...MODULES],
  providers: [
    provideNgxMask(),
    {
      provide: PlatformDynamicComponentsToken,
      useValue: DYNAMIC_COMPONENT_MAPPING,
      multi: true,
    },
  ],
})
export class DynamicRenderComponentsModule {}
